import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_AccommodationListComponent from "../components/_FM_accommodation/_FM_AccommodationListComponent";
import _FM_AccommodationFormComponent from "../components/_FM_accommodation/_FM_AccommodationFormComponent";
import _FM_AccommodationShowComponent from "../components/_FM_accommodation/_FM_AccommodationShowComponent";
import _FM_AccommodationImportFormComponent from "../components/_FM_accommodation/_FM_AccommodationImportFormComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_AccomodatonPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('accommodations') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/accommodation')
  }, []);

  return (
    <div className="_FM_AccomodatonPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/accommodation"}/>
      <Panel>
        <_FM_AccommodationListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {navigate(-1)}}>
        <_FM_AccommodationFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {navigate(-1)}}>
        <_FM_AccommodationShowComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'import' && entity === 'accommodation'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {navigate(-1)}}>
        <_FM_AccommodationImportFormComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_AccomodatonPage);
